/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { Alert, Button, FlexCol, FlexRow } from 'sarsaparilla';
import { now, parseAbsolute } from '@internationalized/date';
import { isValidDateFormat } from 'ui-activitypass/src/utils/date_time_utils';
import { formatDateTimeShortWithWeekDay } from 'ui-activitypass/src/utils/upsell_utils';
import { passSelectionRoute } from '../../../dev/routesArray';

export default function CTABar({ facility, passTypes }) {
    const navigate = useNavigate();
    const passTypesFiltered = passTypes.filter((item) => {
        const isFieldSales = !!item?.features?.is_field_sales;
        return !isFieldSales;
    });
    const hasPassTypes = !!passTypesFiltered.length;

    if (!hasPassTypes) {
        return null;
    }

    const onSaleDate = isValidDateFormat(facility.on_sale_date || facility.active_on)
        ? parseAbsolute(facility.on_sale_date || facility.active_on)
        : now().add({ years: 1 }); // safeguard for missing on sale dates
    const isOnSale = now().compare(onSaleDate) >= 0;
    return (
        <div className="ap-cta-bar">
            <FlexRow>
                <FlexCol>
                    <div className="ap-cta-bar-container">
                        <Button
                            onClick={() => navigate(passSelectionRoute(facility?.id))}
                            className="ap-cta-bar-button"
                            isDisabled={!isOnSale}
                        >
                            Purchase Here
                        </Button>
                        {!isOnSale && (
                            <Alert hasBoxStyling={false} className="ap-cta-bar-alert">
                                Activity Pass will go on sale on{' '}
                                {formatDateTimeShortWithWeekDay(onSaleDate)}
                            </Alert>
                        )}
                    </div>
                </FlexCol>
            </FlexRow>
        </div>
    );
}

CTABar.propTypes = {
    facility: PropTypes.object.isRequired,
    passTypes: PropTypes.array.isRequired,
};
